<div class="form-group">
<!--    <label class="form-group-label">{{'dashboard.widgets.linkWidget.chooseDashboard' | i18n}}:</label>-->
<!--    <select class="form-control" data-ng-model="config.dashboardId" data-ng-options="dashboard.id as dashboard.title for dashboard in dashboards"></select>-->
</div>

